import React from 'react';
import './modal.css';

export default function Modal  ({ onClose,inputData,modalSubmitSubscriptionButton })  {
    return (
        <div className="modal fade" id="mainModal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog main-box p-0" role="document">
                <div className="modal-content normal">
                    <div className="modal-header p-1 d-flex align-items-center">
                        <button data-dismiss="modal" onClick={onClose} className="btn-close-modal"><i className="fa fa-times"></i>
                        </button>
                        <div id="validUntil" className="flex-wrapper d-none">

                            <div className="circle-big" id="circleChartMinute">
                                <div className="text flex-column">
                                    <div className="text-big">15</div>
                                    <div className="small">دقیقه</div>
                                </div>
                                <svg>
                                    <circle className="bg" cx="30" cy="30" r="22.5"></circle>
                                    <circle className="progress" cx="30" cy="30" r="22.5"></circle>
                                </svg>
                            </div>

                            <div className="circle-big" id="circleChartHour">
                                <div className="text flex-column">
                                    <div className="text-big">14</div>
                                    <div className="small">ساعت</div>
                                </div>
                                <svg>
                                    <circle className="bg" cx="30" cy="30" r="22.5"></circle>
                                    <circle className="progress" cx="30" cy="30" r="22.5"></circle>
                                </svg>
                            </div>

                            <div className="circle-big" id="circleChartDay">
                                <div className="text flex-column">
                                    <div className="text-big">12</div>
                                    <div className="small">روز</div>
                                </div>
                                <svg>
                                    <circle className="bg" cx="30" cy="30" r="22.5"></circle>
                                    <circle className="progress" cx="30" cy="30" r="22.5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div id="withoutValidUntil" className="p-3 d-none">
                            <span className="label-success">فعلا معتبر</span>
                        </div>
                        <div id="expired" className="p-3 d-none">
                            <span className="label-danger">منقضی شده</span>
                        </div>
                    </div>
                    <div className="modal-body">
                        <b className="font-20" id="modalTitle">{inputData.title}</b>
                        <p className="font-13 pt-2 line-h-2" id="modalDescription"></p>
                        <div className="row">
                            <div className="col-lg-9 m-auto">
                                <div className="pb-3 font-13" id="modalSiteCouponSection">
                                    <div className="row pt-3 pb-1 d-none" id="modalCodeSection">
                                        <div className="col-4 pl-0">
                                            <button data-clipboard-target="#modalCode" id="code_copy_btn"
                                                    className="btn-copy btn bg-blue radius-30 btn-show w-100 font-15 font-md-17">
                                                کپی کنید
                                            </button>
                                        </div>
                                        <div className="col-8">
                                            <p className="discount-code-input" id="modalCode">{inputData.code}</p>
                                        </div>
                                    </div>
                                    <div className="text-danger text-center font-20" id="modalError"></div>
                                    <button type="button" id="code_action_btn" style={{display: "none"}}
                                            className="btn bg-blue radius-30 btn-show w-100 font-15 font-md-17">
                                        پرداخت امتیاز
                                    </button>
                                    <a href={inputData.link} target="_blank" rel="nofollow"
                                       className="btn bg-blue my-3 radius-30 btn-show w-100 font-17"
                                       id="modalBuyLink">خرید کنید</a>
                                </div>
                                <div className="pb-3 font-13 show-app-dn-link d-none" id="modalAppCouponSection">
                                    <div className="text-center">این کوپن فقط در اپلیکیشن موپن قابل مشاهده است. لطفا از طریق لینک‌های زیر اپلیکیشن موپن را نصب کنید.</div>
                                    <div className="row align-items-center">
                                            <a href="https://cafebazaar.ir/app/ir.mopon.customer/?l=fa" target="_blank" rel="nofollow, noopener" class="col-6 p-0 text-left">
                                            <img src="/images/app/bazaar.png?w=152&h=50" width="152" height="50" data-src="/images/app/bazaar.png?w=152&h=50" alt="دانلود اپ از کافه بازار" class="my-2 pl-1"  loading="lazy"/>
                                            </a>
                                            <a href="https://sibche.com/applications/mopon" target="_blank" rel="nofollow, noopener" class="col-6 p-0 text-right">
                                            <img src="/images/app/sibche.webp?w=152&h=50" width="152" height="50" data-src="/images/app/sibche.webp?w=152&h=50" alt="دانلود اپ از سیبچه"  class="my-2 pr-1" loading="lazy"/>
                                            </a>
                                            </div>
                                </div>
                                <div className="d-flex justify-content-center" style={{paddingBottom:"2.25rem;"}}>
                                    <div className="like-count"><span className="count" id="modalLiked">0</span>
                                        <span className="icon"><i style={{color: 'green'}} className="fa fa-thumbs-up" id="modalLikeButton"></i></span>
                                    </div>
                                    <div className="dis-like-count"><span className="count" id="modalDisliked">0</span>
                                        <span className="icon"><i style={{color: 'red'}} className="fa fa-thumbs-up top-2"
                                                                  id="modalDislikeButton"></i></span>
                                    </div>
                                </div>
                                {/*<div className="separator mb-2 mt-3" style={{height:"1px;width:70%"}}></div>*/}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-sm-3 m-auto">
                                <div className="m-auto text-center d-md-block d-sm-block d-none" id="LogoSection">
                                    <a href="#" id="modalBrandLogoURL">
                                        <img
                                            id="modalImage"
                                            alt=""
                                            data-src={ inputData.logo }
                                            src={ inputData.logo }
                                            width="100"
                                            height="100"
                                        />
                                    </a>


                                </div>
                            </div>
                            <div className="col-12 col-sm-9 pr-md-0 my-auto">
                                <p className="font-15 pr-2 mb-2 mx-auto">
                                    همیشه از آخرین تخفیف‌های <span id="modalBrandName">برند</span> باخبر باشید!
                                </p>
                                <div className="input-group input-custom blue">
                                    <input dir="auto" id="modalEmail" type="text" className="form-control"
                                           placeholder="ایمیل" aria-describedby=""></input>
                                        <div className="input-group-prepend">
                                            <button id="modalSubmitSubscriptionButton" onClick={modalSubmitSubscriptionButton} className="btn bg-blue z-depth-0"
                                                    type="button">ثبت</button>
                                        </div>
                                        <i className="fa fa-envelope font-17"></i>
                                </div>
                                <span id="modalSubsriptionMessage"
                                      className="d-block pt-2 font-13 color-green text-center"></span>
                            </div>
                        </div>
                    </div>
                    <div id="modalfooter">
                        <div className="modal-footer text-right d-block">
                            <a href="#" id="modalBrandLink" className="blue">تمام تخفیف‌های <span></span><i
                                className="fa fa-chevron-left px-1"></i></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/containers/Coupons/modal.js